import Choices from "choices.js";

function initCustomSelects() {

  const forms = document.querySelectorAll('.contact-form-custom');

  if (!forms.length) return;

  forms.forEach(form => {

    const selects = form.querySelectorAll('.contact-form-custom__select');

    selects.forEach(select => {

      if (select.dataset.choices === 'active') return;

      new Choices(select, {
        searchEnabled: false,
        shouldSort: false,
        itemSelectText: '',
        allowHTML: false,
        placeholder: true
      });

      select.dataset.choices = 'active';

    });

  });

}

document.addEventListener('DOMContentLoaded', initCustomSelects);
document.addEventListener('wpcf7init', initCustomSelects);